import axios from "axios";
const config = {
  baseURL: '/saas/api/web',
  timeout: 3600 * 60,
  withCredentials: true,
}

export const fetch = (...args) => axios.create({
  ...config,
  headers: {
    Authorization: localStorage.getItem('Authorization')
  }
})(...args).then(res => res.data);

export const fetchWithoutToken = (...args) => axios.create(config)(...args).then(res => res.data);